import { useUser } from "../../hooks";
import FallbackImage from "../Common/ImageWrapper";
import SubscriptionGate from "./SubscriptionGate";
import "./subscription.css";

/**
 * What staff see instead of the whole app while the plan is not active. No sidebar, header or banners:
 * none of them can be used, so only the cooperative's name and the way forward are shown.
 */
export default function SubscriptionBlockedPage() {
  const user = useUser();
  const name = (user?.company?.name || user?.cooperative_name || "").trim().replace(/\s+/g, " ");
  const logo = user?.company?.logo_url || "/Images/logo1.svg";

  return (
    <div className="sg sg-page">
      <div className="sg-brand">
        <span className="sg-logo">
          <FallbackImage src={logo} alt={name || "Cooperative logo"} width="36" height="36" objectFit="contain" fallback="/Images/logo1.svg" />
        </span>
        {name ? <span className="sg-brand-name">{name}</span> : null}
      </div>
      <main className="sg-main">
        <SubscriptionGate />
      </main>
    </div>
  );
}
